export default __webpack_public_path__ + "static/media/list_main_2_2.bd9b4af9.png";